import axios from '../axios';

const path = '/grazing-heatmap';

const service = {
  fetchGrazingData({ date, rotationIds }) {
    return axios.get(path, { params: { date, rotationIds } });
  },

  fetchGrazingHeatmapStyles() {
    return axios.get(`${path}/styles`);
  }
};

export default service;
